import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { getPreloadedState, saveToLocalStorage } from './localStorage';
import sidebarSlice from './sidebarSlice';
import commonSlice from './commonSlice';
import cartSlice from './cartSlice';
import homeThreeSlice from './homeThreeSlice';
import currentLocationSlice from './currentLocationSlice';

const combinedReducer = combineReducers({
  sidebar: sidebarSlice,
  common: commonSlice,
  cart: cartSlice,
  homeThree: homeThreeSlice,
  currentLocation: currentLocationSlice,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'login/logout') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: getPreloadedState(),
});

function onStateChange() {
  saveToLocalStorage(store.getState());
}

store.subscribe(onStateChange);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
